import React, { useState } from 'react';
import { _T, C } from '../../../shared/theme';
import { s_PB, s_GC, s_TI, s_PL } from '../../../shared/styles';

function PreSessionReflection({exercise, lang, onStart, onBack}) {
  const nl = lang==="nl";
  const [energy, setEnergy] = useState(null);
  const [intention, setIntention] = useState("");
  const [focus, setFocus] = useState(null);
  const energyOpts = nl
    ? [{v:1,label:"Uitgeput",emoji:"😮‍💨"},{v:2,label:"Moe",emoji:"😔"},{v:3,label:"Neutraal",emoji:"😐"},{v:4,label:"Goed",emoji:"🙂"},{v:5,label:"Energiek",emoji:"⚡"}]
    : [{v:1,label:"Drained",emoji:"😮‍💨"},{v:2,label:"Tired",emoji:"😔"},{v:3,label:"Neutral",emoji:"😐"},{v:4,label:"Good",emoji:"🙂"},{v:5,label:"Energized",emoji:"⚡"}];
  const focusOpts = nl
    ? ["Ontspannen","Focussen","Energie opladen","Aanwezig zijn","Stress loslaten","Gewoon bewegen"]
    : ["Relax","Focus","Recharge","Be present","Release stress","Just move"];

  return (
    <div className="fadeUp" style={{padding:"4px 0"}}>
      <button onClick={onBack} style={{background:"none",border:"none",color:C.silver,cursor:"pointer",fontSize:13,marginBottom:16,display:"flex",alignItems:"center",gap:4}}>← {nl?"Terug":"Back"}</button>
      <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:20}}>
        <div style={{width:44,height:44,borderRadius:14,background:`${exercise.color}20`,border:`1px solid ${exercise.color}44`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22}}>{exercise.icon}</div>
        <div>
          <div style={{fontSize:9,color:_T.accent,letterSpacing:3,fontWeight:600}}>{nl?"VOOR DE SESSIE":"PRE-SESSION"}</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:16,color:C.white}}>{nl?exercise.label:exercise.labelEN}</div>
        </div>
      </div>

      <div style={s_GC({marginBottom:14})}>
        <div style={{fontSize:11,color:C.silver,marginBottom:10,fontWeight:600}}>{nl?"Hoe voel je je nu?":"How are you feeling right now?"}</div>
        <div style={{display:"flex",gap:6,justifyContent:"space-between"}}>
          {energyOpts.map(e=>(
            <button key={e.v} onClick={()=>setEnergy(e.v)} style={{flex:1,background:energy===e.v?`${exercise.color}25`:_T.bg4,border:`1.5px solid ${energy===e.v?exercise.color:_T.cardBorderBot}`,borderRadius:12,padding:"10px 4px",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
              <span style={{fontSize:20}}>{e.emoji}</span>
              <span style={{fontSize:9,color:energy===e.v?exercise.color:C.silver,fontWeight:energy===e.v?700:400}}>{e.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div style={s_GC({marginBottom:14})}>
        <div style={{fontSize:11,color:C.silver,marginBottom:10,fontWeight:600}}>{nl?"Wat is je doel voor deze sessie?":"What's your intention for this session?"}</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
          {focusOpts.map(f=>(
            <button key={f} onClick={()=>setFocus(f)} style={s_PL(focus===f, exercise.color)}>{f}</button>
          ))}
        </div>
      </div>

      <div style={s_GC({marginBottom:20})}>
        <div style={{fontSize:11,color:C.silver,marginBottom:8,fontWeight:600}}>{nl?"Persoonlijke noot (optioneel)":"Personal note (optional)"}</div>
        <textarea value={intention} onChange={e=>setIntention(e.target.value)} placeholder={nl?"Waarom doe je dit nu?...":"Why are you doing this now?..."} style={s_TI({minHeight:60,resize:"none",padding:"10px 12px",fontSize:13})}/>
      </div>

      <button style={s_PB({width:"100%",fontSize:15,padding:"14px",opacity:energy&&focus?1:0.5})} disabled={!energy||!focus} onClick={()=>onStart({energy,focus,intention})}>
        ▶ {nl?"Sessie starten":"Start session"} →
      </button>
    </div>
  );
}

export default PreSessionReflection;
